import * as React from "react";
const SvgFiRrFloppyDisks = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-floppy-disks_svg__a)">
      <path
        fill="#062147"
        d="M23.13 4.153 19.894.888C19.469.458 18.513 0 17.763 0H9C6.243 0 4 2.243 4 5v10c0 2.757 2.243 5 5 5h10c2.757 0 5-2.243 5-5V6.266c0-.797-.31-1.549-.87-2.113M11 2h6v4h-6zm11 13c0 1.654-1.346 3-3 3H9c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3v4c0 1.103.897 2 2 2h6c1.103 0 2-.897 2-2V2.828l2.711 2.734a1 1 0 0 1 .289.704zm-4 8a1 1 0 0 1-1 1H9c-4.963 0-9-4.038-9-9V7a1 1 0 1 1 2 0v8c0 3.86 3.141 7 7 7h8a1 1 0 0 1 1 1m-4-13c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3m0 4a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-floppy-disks_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFloppyDisks;
